import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { BOX_BUILDER_SELECT_PRODUCTS_DRAWER } from 'swag-client-common/constants';
import { saveEditedBoxItselfInfo, selectBackButton, uploadBoxLogo, saveBrownBoxInfo } from '../../../../../redux/box-builder/box-builder.actions';
import { STEPS } from '../../../../../redux/box-builder/box-builder.constants';
import { brownBoxLogoLoadingSelector, isEditingBoxTypeBoxIdSelector, uploadedBrownBoxLogoSelector, selectedBrownBoxDataSelector, tapeDataSelector } from '../../../../../redux/box-builder/box-builder.selectors';
import BrownBoxSelection from './brown-box-selection';
const mapStateToProps = createStructuredSelector({
  isBoxTypeEdit: isEditingBoxTypeBoxIdSelector,
  uploadedLogo: uploadedBrownBoxLogoSelector,
  selectedBoxData: selectedBrownBoxDataSelector,
  tapeData: tapeDataSelector,
  isLoading: brownBoxLogoLoadingSelector
});
const mapDispatchToProps = dispatch => ({
  onNext: ({
    isEditMode
  }) => {
    dispatch(saveBrownBoxInfo());
    if (isEditMode) {
      dispatch(saveEditedBoxItselfInfo());
    } else {
      dispatch(showPopup({
        popup: BOX_BUILDER_SELECT_PRODUCTS_DRAWER
      }));
    }
  },
  uploadBrownBoxLogo: logo => {
    dispatch(uploadBoxLogo(logo));
  },
  onBackButton: () => {
    dispatch(selectBackButton(STEPS.BROWN_BOX_SELECTION));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(BrownBoxSelection);